/**
 * https://getbootstrap.com/docs/5.0/components/tooltips/
 */

import Tooltip from 'bootstrap/js/src/tooltip';

const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
